import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as accountApi from "../apis/AccountApi";
import { apiWrapper } from "apis/CommonApi";
import { useAppContext } from "utils/store";

export default function WithdrawPage() {
    return (
        <div id="wrap">
            <Main />
        </div>
    );
}

function Main() {
    return (
        <main id="main" className="main">
            <HeadSection />
            <JoinSection />
        </main>
    );
}

function HeadSection() {
    return (
        <section class="headSection">
            <div class="container cont-960">
                <div class="wrap_head">
                    <div class="wrap_title type2 wrap_txt_title">
                        <Link className="logo bold" to="/">
                            LOGO
                        </Link>
                        <span class="bar"></span>
                        <p class="title">※ 회원 탈퇴를 할 경우 입력하신 개인 정보는 1개월 후 시스템에서 삭제되며, 회원 탈퇴 이후에 다시
                            사용을 원하시면 회원가입을 다시 하셔야 합니다.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

function JoinSection() {
    const { store: { userId } } = useAppContext();
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        setFormDataProperty("userId", "");
        setFormDataProperty("phoneNumber1", "");
        setFormDataProperty("phoneNumber2", "");
        setFormDataProperty("phoneNumber3", "");
        setFormDataProperty("email", "");
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormDataProperty(name, value);
    };

    const handleSubmit = (e) => {
        if (window.confirm("정말로 탈퇴하시겠습니까?")) {
            e.preventDefault();

            const form = e.currentTarget;
            if (form.checkValidity() === false) {
                e.stopPropagation();
            } else if (checkValid() === false) {
                e.stopPropagation();
            } else {
                apiWrapper(async () => {
                    const { userId, phoneNumber1, phoneNumber2, phoneNumber3, email } = formData;
                    const phoneNumber = `${phoneNumber1}${phoneNumber2}${phoneNumber3}`;

                    const { status, data } = await accountApi.deleteAccount(userId, phoneNumber, email);
                    if (data) {
                        alert(`${data}`);
                    }
                });
            }
        }
    }

    const checkValid = () => {
        if (userId !== formData.userId) {
            alert("아이디를 확인해주세요.\n로그인한 아이디와 일치하지 않습니다.");
            return false;
        }

        return true;
    }

    return (
        <section class="joinSection">
            <div class="container cont-960">
                <form onSubmit={handleSubmit}>
                    {formData && (
                        <div class="whiteBoard wrap_findId">
                            <button class="btn_prev">
                                <i class="x-icon icon_prev"></i>
                            </button>
                            <p class="title_whiteBoard">회원탈퇴</p>
                            <div class="wrap_input">
                                <div class="item_input">
                                    <p class="title_item">아이디</p>
                                    <input type="text" class="defaultInput" name="userId" value={formData.userId} onChange={onChange} required="required" />
                                </div>
                                <div class="item_input">
                                    <p class="title_item">휴대폰 번호</p>
                                    <div class="wrap_inner type2">
                                        <div class="wrap_enter">
                                            <input type="number" class="defaultInput" name="phoneNumber1" value={formData.phoneNumber1} onChange={onChange} required="required" />
                                            <input type="number" class="defaultInput" name="phoneNumber2" value={formData.phoneNumber2} onChange={onChange} required="required" />
                                            <input type="number" class="defaultInput" name="phoneNumber3" value={formData.phoneNumber3} onChange={onChange} required="required" />
                                        </div>
                                    </div>
                                </div>
                                <div class="item_input">
                                    <p class="title_item">이메일 주소</p>
                                    <input type="email" class="defaultInput" name="email" value={formData.email} onChange={onChange} required="required" />
                                </div>
                            </div>
                            <button class="btn_orange btn_findId" type="submit">회원탈퇴</button>
                        </div>
                    )}
                </form>
            </div>
        </section>
    );
}